import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductFilterCategories } from 'src/constants/productFilterCategories';
import { DropDownCategories } from 'src/types/generic';
import { useContextSelector } from 'use-context-selector';

import { ViewCatalogProductsContext } from './ViewCatalogProductsContext';

const ExternalProductFilterDropdown = () => {
  const { t } = useTranslation();
  const handleConfirm = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.handleConfirm
  );
  const itemFilter = useContextSelector(ViewCatalogProductsContext, (context) => context.itemFilter);
  const setItemFilter = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setItemFilter
  );
  const setSelectedProduct = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setSelectedProduct
  );
  const setIsProductPanelOpen = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setIsProductPanelOpen
  );
  const setProductSelections = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.setProductSelections
  );

  const handleExternalCatalogFilterChange = useCallback(
    async (e: DropDownListChangeEvent) => {
      const value = e.value as DropDownCategories;

      await handleConfirm(() => {
        setItemFilter(value);
        setSelectedProduct(null);
        setIsProductPanelOpen(false);
        setProductSelections({});
      });
    },
    [handleConfirm, setItemFilter, setSelectedProduct, setIsProductPanelOpen, setProductSelections]
  );

  const translatedFilterCategories = useMemo(
    () => ProductFilterCategories.map((cat) => ({ ...cat, label: t(cat.label) })),
    [t]
  );

  const translatedValue = useMemo(
    () =>
      itemFilter
        ? { ...itemFilter, label: t(itemFilter.label) }
        : translatedFilterCategories[0],
    [itemFilter, t, translatedFilterCategories]
  );

  return (
    <>
      <DropDownList
        id="catalog-category-dropdown"
        className="k-picker-solid product-filter-dropdown"
        style={{ width: 200 }}
        data={translatedFilterCategories}
        textField="label"
        dataItemKey="value"
        value={translatedValue}
        onChange={handleExternalCatalogFilterChange}
      />
    </>
  );
};

export default ExternalProductFilterDropdown;
